import React from 'react';
import { Link } from 'react-router-dom';
import CVs from '../Images/CVs.png';
import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';

function CV({fun}) {
  return (
      <div className='cvdiv'>
      <div className='sampleDiv'>
      <h2>SAMPLE</h2>
      <Link to='/result' state={'Design'} >
            <img src={CVs} alt='' className='Exapmple1img'/>
      </Link>
      </div>
      
      <Fab variant="extended" size="medium" id='CVCnButton' color="primary" 
       onClick={fun} aria-label="add">
        <CloseIcon sx={{ mr: 1 }} />
        Close
      </Fab>
      
    </div>
  )
}

export default CV